export default "__VITE_ASSET__DWo54r4i__"